import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaSmallMediumTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

class KuikaSmallMediumText extends Component<KuikaSmallMediumTextProps> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <span className={classNames("kuika-typography-small--medium", className)} {...props}>
        {children}
      </span>
    );
  }
}

export default KuikaSmallMediumText;
